import { PropsWithRef } from 'react';

interface Props {
  readonly size?: number;
  readonly className?: string;
}

export default function MainnetIcon(props: PropsWithRef<Props>) {
  const { size = 17, className } = props;

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 17 17"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M8.295 11.167 5.833 8.705m2.462 2.462a18.343 18.343 0 0 0 3.282-1.641m-3.282 1.64v4.103s2.486-.451 3.282-1.64c.886-1.33 0-4.103 0-4.103m-5.744-.82a18.05 18.05 0 0 1 1.641-3.242A10.568 10.568 0 0 1 16.5.5c0 2.232-.64 6.154-4.923 9.026m-5.744-.82H1.731s.451-2.487 1.64-3.283c1.33-.886 4.103 0 4.103 0m-5.333 6.974C.911 13.431.501 16.5.501 16.5s3.068-.41 4.102-1.641c.582-.69.574-1.748-.074-2.388a1.789 1.789 0 0 0-2.388-.074Z"
        stroke="currentColor"
        fill="none"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
